import http from "../http/http-config";
import { AmparoGroup } from "../models/amparoGroup";

export default new class typesOptionsGroupService {
    getTypesOptionsGroup(productId, securityGroup, rangeId, onDate, correlationInformation, userName, userToken, tokenType): Promise<AmparoGroup[]> {
        return http.get<AmparoGroup[]>("TypesOptionsGroup", {
            params: {                
                productId,
                securityGroup,
                rangeId,
                onDate,
                correlationInformation,
                userName,
                userToken,
                tokenType
            }
        }).then(response => response.data)
    }
}